var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('GalleryNavbar'),_c('Gallery',{on:{"upload":function($event){return _vm.$emit('upload')}}}),_c('GalleryPagination'),_c('br'),_c('br'),_c('br'),_c('br'),_c('GalleryStatusBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }